<div class="row ws-product-grid">
  @for (column of productColumns; track column) {
    <div class="col-lg-4 col-md-6 ws-product-grid__column">
      @for (cake of column; track cake) {
        @if (cake.id) {
          <div class="position-relative ws-product-grid__item">
            <cake-item
              [cake]="cake"
              [cartLines]="cartLines"
              [showBakeryLine]="showBakeryLine"
              [showCustomNote]="showCustomNote"
              [noteContext]="noteContext"
              [defaultCurrency]="currency"
              [buildCakeUrl]="buildProductUrlGenerator ? buildProductUrlGenerator(cake): ''"
              [bakeryOverviewUrl]="bakeryOverviewUrlGenerator ? bakeryOverviewUrlGenerator(cake.bakery.name): ''"
              [isTouchDevice]="uiContext.isTouchDevice"
              (onDetailsRequest)="onProductOrdered.emit($event)"
              (onRemoveOrderLine)="onRemoveOrderLine.emit($event)"
              (onRemoveCateringMenu)="onRemoveCateringMenu.emit($event)"
              (onPiecesCakeOrder)="onPiecesProductOrdered.emit($event)"
              (onShowPickup)="checkDelivery(DELIVERY_TYPES.PICKUP, cake)"
              (onShowDelivery)="checkDelivery(DELIVERY_TYPES.DELIVERY, cake)"
            ></cake-item>
          </div>
        } @else {
          <div class="position-relative ws-product-grid__item">
            <null-cake-item (click)="onNullItemClick.emit()"></null-cake-item>
          </div>
        }
      }
    </div>
  }
</div>

@if (noImageProducts?.length) {
  @if (productColumns?.length) {
    <hr class="ws-product-grid__divider">
    <div class="ws-product-grid__more-title">
      <strong [translate]="'common.moreProducts'">More products</strong>
    </div>
  }

  <div class="row ws-product-grid">
    @for (cake of noImageProducts; track cake.id) {
      <div class="col-lg-4 col-md-6 ws-product-grid__column">
        <div class="position-relative ws-product-grid__item">
          <cake-item
            [cake]="cake"
            [cartLines]="cartLines"
            [showBakeryLine]="showBakeryLine"
            [showCustomNote]="showCustomNote"
            [noteContext]="noteContext"
            [defaultCurrency]="currency"
            [buildCakeUrl]="buildProductUrlGenerator ? buildProductUrlGenerator(cake): ''"
            [bakeryOverviewUrl]="bakeryOverviewUrlGenerator ? bakeryOverviewUrlGenerator(cake.bakery.name): ''"
            [isTouchDevice]="uiContext.isTouchDevice"
            (onDetailsRequest)="onProductOrdered.emit($event)"
            (onRemoveOrderLine)="onRemoveOrderLine.emit($event)"
            (onRemoveCateringMenu)="onRemoveCateringMenu.emit($event)"
            (onPiecesCakeOrder)="onPiecesProductOrdered.emit($event)">
          </cake-item>
        </div>
      </div>
    }
  </div>
}

@if (productColumns && productColumns.length || noImageProducts?.length) {
  <ng-content></ng-content>
}
